<template>
    <v-app >
      <div class="layout-container" >
        <v-app-bar
          app
          color="green darken-4"
          leight
          clipped-left
          height="5px"
        >
        </v-app-bar>
        <div class="content-container">
            <v-btn
              v-if="showMenuButton"
              class="mx-2 mb-5"
              fab
              dark
              right
              top
              fixed
              color="primary"
              @click.stop="ChangeShowMenu()"
            >
              <v-icon dark>
                mdi-menu
              </v-icon>
            </v-btn>
            <v-navigation-drawer
              v-model="showMenu"
              :hide-overlay = true
              :permanent = "(!$vuetify.breakpoint.smAndDown && showMenu)"
              :mini-variant="mini"
              app
              :ripple="false" class="mb-10"
              :width="mini ? '56': '100'"
              :style="mini ? 'background-color: rgba(255, 255, 255, 0.7) !important;' : 'background-color: rgba(255, 255, 255, 0.9) !important'"
            >

              <v-list>
                <v-subheader style="height:30px">
                  <v-btn v-if="!$vuetify.breakpoint.smAndDown"
                    icon
                    absolute
                    @click.stop="mini = !mini"
                  >
                    <v-icon v-if="mini">mdi-chevron-right</v-icon>
                    <v-icon v-else>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn v-if="$vuetify.breakpoint.smAndDown"
                    icon
                    absolute
                    @click.stop="ChangeShowMenu()"
                  >
                    <v-icon >mdi-chevron-left</v-icon>
                  </v-btn>
                </v-subheader>
                <v-list-item
                class="px-0"
                  to="/"
                  style="padding:0 0px!important" :ripple="false">
                    <v-list-item-icon :style="mini ? 'min-width: 10%;' : 'min-width: 100px;'">
                      <iconHome :width="mini ? '56px' : 100" :height="mini ? '55px' : 100"></iconHome>
                    </v-list-item-icon>
                </v-list-item>
                <v-list-item
                class="px-0"
                to="/tour"
                style="padding:0 0px!important"
                :ripple="false">
                  <v-list-item-icon :style="mini ? 'min-width: 55px;' : 'min-width: 100px;'">
                    <iconTour :width="mini ? 56 : 100" :height="mini ? '55px' : 100"></iconTour>
                  </v-list-item-icon>

                  </v-list-item>

                  <v-list-item to="/search" style="padding:0 0px" :ripple="false">
                    <iconFilter :width="mini ? '55px' : 100" :height="mini ? '55px' : 100"></iconFilter>
                  </v-list-item>
                <v-list-item to="/cave" style="padding:0 0px" :ripple="false">
                    <v-list-item-icon :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconCave :key="'cave-' + (mini ? 'mini' : 'full')" :width="mini ? 55 : 100" :height="mini ? 55 : 100"></iconCave>
                    </v-list-item-icon>
                  </v-list-item>
                <v-list-item to="/pr" style="padding:0 0px" :ripple="false">
                    <v-list-item-icon :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconPaintedRepresentation :width="mini ? '55px' : 100" :height="mini ? '55px' : 100" ></iconPaintedRepresentation>
                    </v-list-item-icon>
                  </v-list-item>
                <v-list-item to="/bibliography" style="padding:0 0px" :ripple="false">
                    <v-list-item-icon :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconBibliography :width="mini ? '55px' : 100" :height="mini ? '55px' : 100" ></iconBibliography>
                    </v-list-item-icon>
                  </v-list-item>
                <v-list-item to="/iconography" style="padding:0 0px" :ripple="false">
                    <v-list-item-icon :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconIconography :width="mini ? '55px' : 100" :height="mini ? '55px' : 100" ></iconIconography>
                    </v-list-item-icon>
                  </v-list-item>
                <v-list-item to="/about" style="padding:0 0px!important" :ripple="false">
                    <v-list-item-icon title="About"  :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconAbout :width="mini ? 56 : 100" :height="mini ? 56 : 100" ></iconAbout>
                      <title>About the Database</title>
                    </v-list-item-icon>
                </v-list-item>
                <v-list-item v-if="true" style="padding:0 0px!important" :ripple="false"
                  class="px-2"
                  to="/forum"
                >
                    <v-list-item-icon :style="mini ? 'min-width: 56px;min-height: 56px;' : 'min-width: 100px;min-height: 100px;'">
                      <iconDiscussion :width="mini ? 56 : 100" :height="mini ? 56 : 100" ></iconDiscussion>
                      <title>Discussion Forum</title>
                    </v-list-item-icon>
                </v-list-item>
                <v-list-item to="/impressum" style="padding:0 0px!important" :ripple="false"
                  class="px-2"
                >
                    <v-list-item-icon :style="mini ? 'min-width: 56px;' : 'min-width: 100px;'">
                      <iconImpressum :width="mini ? 56 : 100" :height="mini ? 56 : 100" ></iconImpressum>
                    </v-list-item-icon>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
            </v-navigation-drawer>
          <v-main class="scroll fix" >
            <v-dialog width="550" v-model="showIiifAlert">
              <v-card>
                <v-card-title>Service Announcement</v-card-title>
                <v-card-text>
                  Please note: Our IIIF server is currently experiencing technical difficulties, temporarily affecting the display images. We are actively working on a resolution and apologize for any disruption to your research.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" block @click="showIiifAlert = false">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog width="500" v-model="isTestVersion">
              <v-card title="Test Phase Ended">
                <v-card-title>Test Phase Ended!</v-card-title>
                <v-card-text>
                  This is only a test instance of the kucha mural information system please got to: <a href="https://kucha.saw-leipzig.de">https://kucha.saw-leipzig.de</a> if you are not testing a new version.
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" block target="_self" @click="isTestVersion = false">OK</v-btn>
                </v-card-actions>
              </v-card>
          </v-dialog>
            <div class="page-container">
              <router-view class="page-content" />
            </div>
          </v-main>
        </div>
    </div>


    <v-footer
      app
      color="black"
      height="80px"
      style="border-top:10px solid rgba(60, 179, 113,0.55) !important;background-clip: padding-box!important;"
    >
      <v-row no-gutters style="height:100%">
        <v-col cols="8">
          <div content style="font-size: 0.8rem;color:white;position: absolute;left: 20px; text-align: left;" v-html="getFooter"> </div>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-layout warp class="justify-end" style="height: 100%;">
            <div class="logo text-right" v-html="logo"     style="
                color:white;
                width:200px;
                display:flex;
                align-items:center;
                justify-content:center;
                height:100%;
            "></div >
            <LoginComponent v-if="!$store.state.user.sessionID" style="margin-top: auto;margin-bottom: auto;" />
            <usermanager v-if="$store.state.user.sessionID" style="margin-top: auto;margin-bottom: auto;" />
          </v-layout>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>

</template>

<script>
import {logo, logoSmwk} from '@/utils/constants'
import iconCave from '@/components/icons/iconCave'
import iconPaintedRepresentation from '@/components/icons/iconPaintedRepresentation'
import iconBibliography from '@/components/icons/iconBibliography'
import iconHome from '@/components/icons/iconHome'
import iconIconography from '@/components/icons/iconIconography'
import iconAbout from '@/components/icons/iconAbout'
import iconImpressum from '@/components/icons/iconImpressum'
import iconFilter from '@/components/icons/iconFilter'
import iconTour from '@/components/icons/iconTour'
import iconDiscussion from '@/components/icons/iconDiscussion'
import LoginComponent from '@/components/LoginDialog'
import usermanager from '@/components/usermanager'
import {isLoggedIn} from '@/services/repository'

export default {
  name: 'App',
  data () {
    return {
      isTestVersion: false,
      route: window.location.hash,
      show: false,
      drawer: null,
      navigation: true,
      mini: true,
      query: '',
      logo: logo,
      logoSmwk: logoSmwk,
      showMenuButton: false,
      showIiifAlert: true,
    }
  },
  created() {
  },
  components: {
    usermanager,
    LoginComponent,
    iconCave,
    iconPaintedRepresentation,
    iconBibliography,
    iconHome,
    iconIconography,
    iconAbout,
    iconImpressum,
    iconFilter,
    iconTour,
    iconDiscussion
  },
  computed:{
    breakpoint(){
      return this.$vuetify.breakpoint.smAndDown;
    },
    isTopPage(){
      if (location.href.toLowerCase().includes("news") || location.href.toLowerCase().includes("home") || location.href.toLowerCase().includes("login")){
        return false
      } else {
        return true
      }
    },
    showMenu:{
      get: function(){
        return this.$store.state.showMenu
      },
      set: function(newValue){
        this.$store.commit("setShowMenu", newValue)
      }
    },
    breadcrumb:{
      get: function(){
        return this.$store.state.breadcrumb;
      },
      set: function (newValue){
        this.$store.commit("setBreadcrumb", newValue)
      }
    },
    checkLandscape(){
      return this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height
    },
    getFooter(){
      return !this.$vuetify.breakpoint.smAndDown ? "2024, version 1.0.1 <br>Note: We welcome any kind of user feedback, be it on practical matters concerning <br> the website or comments on and questions about the content. Please contact <a href='mailto:kuchaadmin@saw-leipzig.de'> admin </a>" : "2023,<br> version 1.0.1"
    }
  },
  methods: {
    hideOverlay(){
      return !this.$vuetify.breakpoint.smAndDown
    },
    setChecked(item){
      item['checked'] = false
      for (let child of item.children){
        this.setChecked(child)
      }
    },
    ChangeShowMenu(){
      this.showMenu = !this.showMenu
    },
    breakpointChanched(){
      if (!this.$vuetify.breakpoint.smAndDown){
        this.showMenuButton = false
      } else {
        if (location.pathname.toLowerCase().includes("news") || location.pathname.toLowerCase() === "/"){
          this.showMenuButton = false
        } else {
          this.showMenuButton = !this.showMenu
        }
      }

    }

  },
  beforeMount:function () {
    if (this.$store.state.user.sessionID){
      if (this.$store.state.user.sessionID !== "") {
        isLoggedIn(this.$store.state.user.sessionID)
          .then((res) => {
            this.$store.commit("setUser", res.data)
          })
          .catch((err) => {
            console.log("error!", err.response);
            this.$store.commit("setUser", {})
          })
      }
    }
    this.$store.dispatch('getIconography')
    this.$log.debug("starting fetch cave entries")
    this.$store.dispatch('fetchCaveEntries')
    this.$store.dispatch('getWallLocation')
    if (!this.$store.state.wallLocation || this.$store.state.wallLocation.length === 0){

      this.$store.dispatch('getWallLocation')
    }
    this.$store.dispatch('fetchMapping')
    this.$store.dispatch('getDiscussionMapping')
    this.$store.dispatch('getLocations')
  },
  watch: {
    showMenu(newVal, oldVal){
      this.breakpointChanched();
    },
    breakpoint(newVal, oldVal){
      if (newVal){
        this.showMenu = false;
      }
      this.breakpointChanched();
    }
  },
  mounted:function(){
    if (window.location.origin.includes("test")){
      this.isTestVersion = true;
    }
    if (this.$vuetify.breakpoint.smAndDown){
      this.navigation = false
      this.mini = false
    } else {
      this.mini = true
      this.navigation = true
    }
  },
}
</script>
<style lang="css" scoped>
.layout-container {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.content-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.page-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.page-content {
  width: 100%;
  min-width: 0;
}
.logo svg {
    display: block;
}
</style>